import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EmployeeAttendanceComponent } from './employee-attendance/employee-attendance.component';
import { EmployeeManagerComponent } from './employee-manager/employee-manager.component';
import { EmployeeSalaryComponent } from './employee-salary/employee-salary.component';
import { EmployeeTimeshiftComponent } from './employee-timeshift/employee-timeshift.component';
import { PhoneCallComponent } from './phone-call/phone-call.component';
import { PhoneManagerComponent } from './phone-manager/phone-manager.component';
import { PhoneRecordComponent } from './phone-record/phone-record.component';
import { OrderBookingComponent } from './order-booking/order-booking.component';
import { OrderManagerComponent } from './order-manager/order-manager.component';
import { OrderProductionComponent } from './order-production/order-production.component';
import { OrderWarehouseComponent } from './order-warehouse/order-warehouse.component';
import { WarehouseExportComponent } from './warehouse-export/warehouse-export.component';
import { WarehouseImportComponent } from './warehouse-import/warehouse-import.component';
import { WarehouseManagerComponent } from './warehouse-manager/warehouse-manager.component';
import { WarehouseMaterialComponent } from './warehouse-material/warehouse-material.component';
import { WarehouseSupplierComponent } from './warehouse-supplier/warehouse-supplier.component';
import { WarehouseUnitComponent } from './warehouse-unit/warehouse-unit.component';
import { ProductManagerComponent } from './product-manager/product-manager.component';
import { ProductGroupComponent } from './product-group/product-group.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SharedModule } from '../../shared.module';
import { StoreManagerComponent } from './store-manager/store-manager.component';
import { StoreOrderComponent } from './store-order/store-order.component';
import { StoreImportComponent } from './store-import/store-import.component';
import { EmployeeGroupComponent } from './employee-group/employee-group.component';
import { PhoneContactComponent } from './phone-contact/phone-contact.component';
import { ChatComponent } from './chat/chat.component';
import { UploadModule } from "../../pipes/upload/upload.module";
import { WorkCalendarComponent } from './work-calendar/work-calendar.component';
import { PhoneRecordReportComponent } from './phone-record-report/phone-record-report.component';
import { MultiSelectModule } from '../../pipes/multi-select/multi-select.module';
import { PwaComponent } from './pwa/pwa.component';
import { EmployeeOvertimeComponent } from './employee-overtime/employee-overtime.component';
import { SalaryFormulaComponent } from './salary-formula/salary-formula.component';
import { FormulaTimekeepingComponent } from './formula-timekeeping/formula-timekeeping.component';
import { EmployeeFaceComponent } from './employee-face/employee-face.component';
import { EmployeeRelocationComponent } from './employee-relocation/employee-relocation.component';
import { EmployeeAbsenceComponent } from './employee-absence/employee-absence.component';
import { EmployeeLeaveComponent } from './employee-leave/employee-leave.component';
import { EmployeeStoreComponent } from './employee-store/employee-store.component';



@NgModule({
  declarations: [
    EmployeeAttendanceComponent,
    EmployeeManagerComponent,
    EmployeeSalaryComponent,
    EmployeeTimeshiftComponent,
    PhoneCallComponent,
    PhoneManagerComponent,
    PhoneRecordComponent,
    OrderBookingComponent,
    OrderManagerComponent,
    OrderProductionComponent,
    OrderWarehouseComponent,
    WarehouseExportComponent,
    WarehouseImportComponent,
    WarehouseManagerComponent,
    WarehouseMaterialComponent,
    WarehouseSupplierComponent,
    WarehouseUnitComponent,
    ProductManagerComponent,
    ProductGroupComponent,
    UserProfileComponent,
    StoreManagerComponent,
    StoreOrderComponent,
    StoreImportComponent,
    EmployeeGroupComponent,
    PhoneContactComponent,
    ChatComponent,
    WorkCalendarComponent,
    PhoneRecordReportComponent,
    PwaComponent,
    EmployeeOvertimeComponent,
    SalaryFormulaComponent,
    FormulaTimekeepingComponent,
    EmployeeFaceComponent,
    EmployeeRelocationComponent,
    EmployeeLeaveComponent,
    EmployeeAbsenceComponent,
    EmployeeStoreComponent,

  ],
  imports: [
    SharedModule,
    CommonModule,
    UserRoutingModule,
    ReactiveFormsModule,
    TranslateModule,
    UploadModule,
    MultiSelectModule
  ]
})
export class UserModule { }
